<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg aria-hidden="true">
        <use href="assets/icons.svg#geo-marker"></use>
      </svg>
      <span>Select lead prospect</span>
    </h3>
  </div>

  <div class="card-content">
    <div class="content-section">
      <div class="card-intro">
        <svg aria-hidden="true">
          <use href="assets/icons.svg#people"></use>
        </svg>
        <p>Select a lead to begin the sales process</p>
      </div>

      <!-- Controls Grid -->
      <div class="controls-grid two-one-grid">
        <!-- SEARCH FIELD -->
        <div class="form-field">
          <label for="search" class="field-label">Search Leads</label>

          <div class="search-input-wrapper">
            <svg aria-hidden="true">
              <use href="assets/icons.svg#searchglass"></use>
            </svg>

            <input
              id="search"
              type="text"
              class="search-input"
              placeholder="Search by address or postcode"
              [(ngModel)]="searchQuery"
              (input)="filterLeads()"
            />
          </div>
        </div>


      </div>

      <!-- FILTERS -->
      <div class="controls-grid">
        <!-- SORT -->
        <div class="form-field">
          <label for="sort-select" class="field-label">Sort by</label>
          <select
            id="sort-select"
            class="filter-select"
            [(ngModel)]="sortBy"
            (change)="sortLeads()"
          >
            <option value="address">Address</option>
            <option value="postcode">Postcode</option>
            <option value="district">Local Authority District</option>
          </select>
        </div>

        <!-- FILTER STATUS -->
        <div class="form-field">
          <label for="filter-status" class="field-label">Filter Status</label>
          <select
            id="filter-status"
            class="filter-select"
            [(ngModel)]="filterStatus"
            (change)="filterLeads()"
          >
            <option value="">All Statuses</option>
            <option value="new">New</option>
            <option value="in-progress">In Progress</option>
            <option value="closed">Closed</option>
          </select>
        </div>
      </div>
    </div>

    <!-- LEADS LIST -->
    <div class="leads-list">
      @for (lead of filteredLeads; track trackByUprn($index, lead)) {
        <div
          class="lead-card"
          (click)="selectLead(lead)"
          [class.selected]="selectedLead === lead"
          role="button"
          tabindex="0"
        >
          <div class="lead-content">
            <div class="lead-main">
              <div class="lead-address-section">
                <h4 class="lead-address">{{ lead.singleLineAddress }}</h4>

                <button
                  class="external-link-btn"
                  type="button"
                  (click)="openMap(lead)"
                  aria-label="Open map for {{ lead.singleLineAddress }}"
                >
                  <svg aria-hidden="true">
                    <use href="assets/icons.svg#link"></use>
                  </svg>
                </button>
              </div>

              <p class="lead-detail">{{ lead.postcode }}</p>

              <div class="lead-stats">
                <div class="stat-item">
                  <svg aria-hidden="true">
                    <use href="assets/icons.svg#people"></use>
                  </svg>
                  <span>UPRN: {{ lead.uprn }}</span>
                </div>

                <div class="stat-item">
                  <svg aria-hidden="true">
                    <use href="assets/icons.svg#geo-marker"></use>
                  </svg>
                  <span>{{ lead.localAuthorityDistrict }}</span>
                </div>
              </div>
            </div>

            <div class="lead-badges">
              <span class="badge badge-new">{{ lead.status }}</span>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- SELECTED LEAD -->
    @if (selectedLead) {
      <div class="selected-lead">
        <h4>Selected Lead:</h4>
        <p>{{ selectedLead.singleLineAddress }}, {{ selectedLead.postcode }}</p>
        <p>{{ selectedLead.localAuthorityDistrict }}</p>
        <p>Status: {{ selectedLead.status }}</p>
      </div>
    }

    <!-- ACTION BUTTONS -->
    <div class="action-buttons">
      <button class="btn btn-secondary" type="button">Check Eligibility</button>

      <button
        class="btn btn-primary"
        type="button"
        [disabled]="!selectedLead"
        (click)="goToEligibility()"
      >
        Continue with Lead
      </button>
    </div>
  </div>
</div>

